<template>
  <div class="bg-[#23242A] text-white  px-6 pt-1 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto">
      <div :class="'flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
        <div class="custom-full" v-if="can_view_or_manage_vault">
          <block-loading v-if="loadingBadges"/>
          <template v-else>

            <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]">
              <div class="mb-3 ">
                  <div class="text-[24px] text-white px-4 pt-4">
                          <div class="flex justify-between relative">
                            <input v-model="search" type="text" class="rounded w-full relative pl-9 h-[40px] bg-[#464851] align-top mr-4 border-0" placeholder="Search by Bank Deposit #, Transaction Type, or User" />
                            <svg width="24" height="24" class="absolute top-[9px] left-[8px]" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M19.9 20.9751L13.325 14.4001C12.825 14.8334 12.2417 15.1709 11.575 15.4126C10.9083 15.6543 10.2 15.7751 9.45 15.7751C7.65 15.7751 6.125 15.1501 4.875 13.9001C3.625 12.6501 3 11.1418 3 9.3751C3 7.60843 3.625 6.1001 4.875 4.8501C6.125 3.6001 7.64167 2.9751 9.425 2.9751C11.1917 2.9751 12.6958 3.6001 13.9375 4.8501C15.1792 6.1001 15.8 7.60843 15.8 9.3751C15.8 10.0918 15.6833 10.7834 15.45 11.4501C15.2167 12.1168 14.8667 12.7418 14.4 13.3251L21 19.8751L19.9 20.9751ZM9.425 14.2751C10.775 14.2751 11.925 13.7959 12.875 12.8376C13.825 11.8793 14.3 10.7251 14.3 9.3751C14.3 8.0251 13.825 6.87093 12.875 5.9126C11.925 4.95426 10.775 4.4751 9.425 4.4751C8.05833 4.4751 6.89583 4.95426 5.9375 5.9126C4.97917 6.87093 4.5 8.0251 4.5 9.3751C4.5 10.7251 4.97917 11.8793 5.9375 12.8376C6.89583 13.7959 8.05833 14.2751 9.425 14.2751Z" fill="white"/>
                            </svg>

                            <div class="flex flex-row border-l border-[#464851] pl-4">
                              <div class="relative" tabIndex="0"  @blur="closeDropDown">
                                  <div @click="toggleDropDown" class="text-white  bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer">
                                      <span>
                                          <svg fill="currentColor" width="32" height="32" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z"></path>
                                          </svg>
                                      </span>
                                  </div>
                                  
                                  <div v-if="toggleAddDropDown" class="absolute top-14 right-0 w-60   mt-1  z-10 rounded-md shadow-lg">
                                      <div class="absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black"></div>
                                      <ul role="listbox" aria-labelledby="listbox-label" aria-activedescendant="listbox-item-3" class="bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                          <li @click.prevent="openModal('BankDeposit')" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                              <div class="flex items-center">
                                                  <span class="ml-3 block text-white font-normal truncate uppercase">
                                                      Bank Deposit
                                                  </span>
                                              </div>
                                          </li>
                                          <li @click.prevent="openModal('AddCash')" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                              <div  class="flex items-center">
                                                  <span class="ml-3 block text-white font-normal truncate uppercase">
                                                      Add/Remove Cash
                                                  </span>
                                              </div>
                                          </li>
                                          <li @click.prevent="openModal('SafeAudit')" role="option" class="cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9">
                                              <div class="flex items-center">
                                                  <span class="ml-3 block text-white font-normal truncate uppercase">
                                                      Safe Audit
                                                  </span>
                                              </div>
                                          </li>
                                      </ul>
                                  </div>
                              </div>
                              <div class="w-[114px] hover:opacity-70 rounded text-center flex justify-center items-center ml-4 bg-white">
                                <button @click.prevent="openModal('CloseVault')" class="font-normal text-base  leading-5 text-[#2BA66B]">Close Vault</button>
                              </div>
                            </div>
                          </div>
                      </div>
              </div>
              <List :current="false" :selectedCallback="selectedItem" :search="search" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/> 
            </div>
          </template>
        </div>
        <restriction-alert v-else/>
    
        <div :class="'w-full hidden-component z-10'" v-if="action.component" >
          <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
        </div>
    </div>
  </div>
  <div>
    <component :is="cashModal.type" v-if="cashModal.popup" @close="closeCreate" :totalBalance="totalBalance" />
  </div>
</template>


<script lang="ts">
import Helpers from '@/helpers';
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/CashMgmt/Vault/CashVault/List.vue';
import Add from '@/views/Membership/Program/Badges/Add.vue';
import Update from '@/views/Membership/Program/Badges/Update.vue';
import Nav from "@/views/Membership/Program/Nav.vue";
import AddCash from '@/views/CashMgmt/Vault/CashVault/AddCash.vue'
import ViewCash from '@/views/CashMgmt/Vault/CashVault/ViewCash.vue'
import BankDeposit from '@/views/CashMgmt/Vault/CashVault/BankDeposit.vue'
import CloseVault from '@/views/CashMgmt/Vault/CashVault/CloseVault.vue'
import SafeAudit from '@/views/CashMgmt/Vault/CashVault/SafeAudit.vue'
import ViewSafeAudit from '@/views/CashMgmt/Vault/CashVault/ViewSafeAudit.vue'

export default defineComponent({
  name: "CashVault",
  props: ['totalBalance'],
  components: {
    Nav,
    List,
    Add,
    Update,
    AddCash,
    ViewCash,
    BankDeposit,
    CloseVault,
    SafeAudit,
    ViewSafeAudit,
  },
  

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    const loyaltyProgram = <any>ref({
      id: null
    });
    const toggleAddDropDown = ref(false)
    const earningSetting = ref({});
    const loadingBadges = ref(false);
    const cashModal = ref({
      popup: false,
      type: ''
    })
    const search = ref('')
    return {
      action,
      earningSetting,
      loyaltyProgram,
      loadingBadges,
      toggleAddDropDown,
      cashModal,
      search
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    /**
     * View restriction
     */
     can_view_or_manage_vault() {
      return Helpers.getMyPermission('can_view_or_manage_vault')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  async mounted() {
    this.emitter.on("reset-badges-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-badges-component', () => {});
  },
 
  methods: {
    openModal(type){
      this.cashModal = {
        type: type,
        popup: true
      }
    },
    toggleDropDown(){
      this.toggleAddDropDown = !this.toggleAddDropDown
    },
    closeDropDown(){
      this.toggleAddDropDown = false
    },
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      console.log(item)
      if(item.transactionType=='audit' || item.transactionType=='safe audit' || item.transactionType=='float' || item.transactionType=='close vault'){
        this.addUpdate({
          component: 'ViewSafeAudit', 
          data: item
        })
      }else{
        this.addUpdate({
          component: 'ViewCash', 
          data: item
        })
      }
    },

    closeCreate(reload){
      this.cashModal.popup = false
      if(reload){
        this.emitter.emit('refresh-vault-list')
        this.emitter.emit('refresh-vault-balance')
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>


